import { EventEmitter, Inject, Injectable, InjectionToken } from '@angular/core';
import { StateButton } from 'estensa-module';
import { noop } from 'lodash-es';

export const ESTENSA_MODULE_BUS_SERVICE = new InjectionToken('estensa.module.bus.service');

// TODO: Considerare se fare lo stesso della controparte AngularJS, definendo le varie interfacce.
export interface IBusData {
    messageType: string;
    data?: any;
}

export interface ITpIntegrationRunBusMessage {
    messageType: 'ESTENSA_TP_INTEGRATION_RUN';
    integrationData: {
        id: string;
        data: any;
    };
}

export interface ITpIntegrationAskButtonsBusMessage {
    messageType: 'ESTENSA_TP_INTEGRATION_ASK_BUTTONS';
    pageName: string;
}

export interface ITpIntegrationStateButtonsBusMessage {
    messageType: 'ESTENSA_TP_INTEGRATION_BUTTONS';
    buttons: ITpIntegrationStateButtonsData[];
}

export interface ITpIntegrationAskStateButtonsStatusBusMessage {
    messageType: 'ESTENSA_TP_INTEGRATION_ASK_BUTTONS_STATUS';
    pageName: string;
    data: any;
}

export interface ITpIntegrationUpdateStateButtonsStatusBusMessage {
    messageType: 'ESTENSA_TP_INTEGRATION_UPDATE_BUTTONS_STATUS';
    updates: {
        id: string;
        disabled: boolean;
    }[];
}

export interface ITpIntegrationGenericMessage {
    messageType: 'ESTENSA_TP_INTEGRATION_GENERIC';
    messageName: string;
    data: any;
}

export interface ITpIntegrationStateButtonsData {
    idIntegration: string;
    position?: number;
    button: StateButton;
}

export interface ISissWayTokenMessage {
    messageType: 'ESTENSA_SISSWAY_TOKEN';
    token: string | null;
}

export interface ISissWayTokenRequestMessage {
    messageType: 'ESTENSA_REQUEST_SISSWAY_TOKEN';
    userId: string;
}

export const isTpIntegrationRunBusMessage = (message: unknown): message is ITpIntegrationRunBusMessage =>
    !!message &&
    typeof message === 'object' &&
    'messageType' in message &&
    message.messageType === 'ESTENSA_TP_INTEGRATION_RUN';

export const isTpIntegrationAskButtonsBusMessage = (message: unknown): message is ITpIntegrationAskButtonsBusMessage =>
    !!message &&
    typeof message === 'object' &&
    'messageType' in message &&
    message.messageType === 'ESTENSA_TP_INTEGRATION_ASK_BUTTONS';

export const isTpIntegrationStateButtonsBusMessage = (
    message: unknown,
): message is ITpIntegrationStateButtonsBusMessage =>
    !!message &&
    typeof message === 'object' &&
    'messageType' in message &&
    message.messageType === 'ESTENSA_TP_INTEGRATION_BUTTONS';

export const isTpIntegrationAskStateButtonsStatusBusMessage = (
    message: unknown,
): message is ITpIntegrationAskStateButtonsStatusBusMessage =>
    !!message &&
    typeof message === 'object' &&
    'messageType' in message &&
    message.messageType === 'ESTENSA_TP_INTEGRATION_ASK_BUTTONS_STATUS';

export const isTpIntegrationUpdateStateButtonsStatusBusMessage = (
    message: unknown,
): message is ITpIntegrationUpdateStateButtonsStatusBusMessage =>
    !!message &&
    typeof message === 'object' &&
    'messageType' in message &&
    message.messageType === 'ESTENSA_TP_INTEGRATION_UPDATE_BUTTONS_STATUS';

export const isSissWayTokenRequestMessage = (message: unknown): message is ISissWayTokenRequestMessage =>
    !!message &&
    typeof message === 'object' &&
    'messageType' in message &&
    message.messageType === 'ESTENSA_REQUEST_SISSWAY_TOKEN';

export const isTpIntegrationGenericMessage = (
    message: unknown
): message is ITpIntegrationGenericMessage =>
    !!message &&
    typeof message === 'object' &&
    'messageType' in message &&
    message.messageType === 'ESTENSA_TP_INTEGRATION_GENERIC';

export interface IBusServiceNg1 {
    notify(data: IBusData): void;

    register(fn: (data: IBusData) => void): void;
}

@Injectable()
export class NullBusService implements IBusServiceNg1 {
    notify = noop;
    register = noop;
}

@Injectable({
    providedIn: 'root',
})
export class EstensaBusWrapperService {
    // events

    busDataFired: EventEmitter<any> = new EventEmitter<any>();

    // constructor

    constructor(@Inject(ESTENSA_MODULE_BUS_SERVICE) private estensaBusService: IBusServiceNg1) {
        this.estensaBusService.register((busData) => {
            this.busDataFired.emit(busData);
        });
    }

    // public functions

    notify(busData: IBusData) {
        this.estensaBusService.notify(busData);
    }
}
